import './index.scss';
import LogoR from '../../assets/images/logo-R(1).png';
import LogoSub from '../../assets/images/logo_sub.png';
import {Link, NavLink} from 'react-router-dom';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faHome, faUser, faScroll, faBriefcase, faAward, faGraduationCap} from '@fortawesome/free-solid-svg-icons';
import {faLinkedin, faGithub} from '@fortawesome/free-brands-svg-icons';

const Sidebar = () => {
    return (
        <div className = 'nav-bar'>

            <Link className = 'logo' to = '/'>
                <img src = {LogoR} alt = 'logo'/>
                <img style = {{'margin-top':'-30px'}} src = {LogoSub} alt = 'logo'/>

            </Link>

            <nav> 
                <NavLink exact = 'true' activeclassname='active' to='/'>
                        <FontAwesomeIcon icon={faHome} color ='#4d4d4e'/>
                </NavLink>
                
                <NavLink exact = 'true' activeclassname='active' className ='about-link' to='/about'>
                        <FontAwesomeIcon icon={faUser} color ='#4d4d4e'/>
                </NavLink>

                <NavLink exact = 'true' activeclassname='active' className ='skills-link' to='/hackathons'>
                        <FontAwesomeIcon icon={faAward} color ='#4d4d4e'/>
                </NavLink>

                
                <NavLink exact = 'true' activeclassname='active' className ='research-link' to='/research'>
                        <FontAwesomeIcon icon={faScroll} color ='#4d4d4e'/>
                </NavLink>

                
                <NavLink exact = 'true' activeclassname='active' className ='work-link' to='/work-ex'>
                        <FontAwesomeIcon icon={faBriefcase} color ='#4d4d4e'/>
                </NavLink>
            </nav>

            <ul className = 'nav-ul'>
                <li>
                    <a target = '_blank' href = 'https://www.linkedin.com/in/rohan-leekha-812221159/' rel = 'noreferrer'>
                        <FontAwesomeIcon icon={faLinkedin} color ='#4d4d4e'/>
                    </a>
                </li>

                <li>
                    <a target = '_blank' href = 'https://github.com/rohan-dot' rel = 'noreferrer'>
                        <FontAwesomeIcon icon={faGithub} color ='#4d4d4e'/>
                    </a>
                </li>

                <li>
                    <a target = '_blank' href = 'https://scholar.google.com/citations?user=dTSnvFEAAAAJ&hl=en' rel = 'noreferrer'>
                        <FontAwesomeIcon icon={faGraduationCap} color ='#4d4d4e'/>
                    </a>
                </li>
            </ul>
        </div>
    )
}

export default Sidebar; 